<template>
  <div class="relative">
    <img
      src="@/assets/images/line/Frame 1000002302.png"
      alt="lineimg"
      class="m-auto px-4"
    />
    <modal :show.sync="editModal" header-classes="bg-primary p-5" size="lg">
      <h6
        slot="header"
        class="modal-title text-white modal-close-btn font-semibold"
      >
        Caregiver Saathi
      </h6>
      <div class="mt-5">
        <p class="mt-2 input-title-black">By submitting this form:</p>
        <p class="mt-2 input-title-black">
          1) You let Caregiver Saathi and its partners use this data for
          insights and analytics. You are not flooded with unnecessary
          information, and it enables us to send you more relevant information
          and resources to support you.
        </p>
        <p class="mt-2 input-title-black">
          2) You agree to be contacted with information and future programs,
          events,promotions, pertaining to the areas of interest you have
          specified in this form.
        </p>
      </div>
      <template slot="footer">
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <div class="absolute bg-design-mbr-ell mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr ell.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design-mbr-ell2 mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr ell.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design-mbr-poly-hcp mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr-poly.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="relative">
      <div class="">
        <div class="w-2/5 bg-b5e7f7">
          <img
            src="../../../assets/images/caregiver/mbr-bg.svg"
            alt="bg polygon"
          />
        </div>
      </div>
      <div class="lg:flex md:flex gap-2 lg:px-10 md:px-10 px-5 absolute top-4">
        <div class="lg:w-1/2 md:w-1/3">
          <p
            class="title w-full sm-fsize16 md:font-normal lg:font-normal font-bold"
          >
            Customised Service
          </p>
          <p class="subtitle md:pt-6 lg:pt-6 pt-2 fsize20 sm-fsize14 lg:w-1/2">
            We offer customised curriculums for group trainings based on your
            need. Share with us details about your organisation and what you are
            aiming for.  Fill in the inquiry form below and we will get in
            touch .
          </p>
        </div>
        <div class="lg:w-1/2 md:w-1/2 formposition md-right">
          <div
            class="col-span-4 bg-primary md:rounded-3xl lg:rounded-3xl rounded-xl md:p-8 lg:p-8 p-4 shadow-b-2xl relative trans-zoom-half"
          >
            <div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(handleSend)">
                  <div class="flex justify-between">
                    <p class="font-bold text-white fsize35-20 mb-2">
                      For Group Offers
                    </p>
                    <!-- <div class="md:hidden lg:hidden block clr858585">
                        <p class="mbr-title mb-2 text-2xl-imp clr858585">
                          Price - ₹0.00
                        </p>
                      </div> -->
                  </div>
                  <div
                    class="pt-6 grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 grid-rows-3 gap-x-5 gap-y-6"
                  >
                    <div class="">
                      <p class="input-title">Name</p>
                      <base-input
                        v-model="name"
                        placeholder="Enter your name"
                        class="md:border-0 lg:border-0"
                        name="Name"
                        :rules="{ required: true, alpha_spaces: true }"
                      ></base-input>
                    </div>
                    <div class="mob-hidden">
                      <p class="input-title">Email Address</p>
                      <base-input
                        v-model="email"
                        placeholder="Enter your EmailID"
                        class="md:border-0 lg:border-0"
                        name="Email"
                        :rules="{ required: true, email: true }"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title">Designation</p>
                      <base-input
                        v-model="designation"
                        placeholder="Enter your Designation"
                        class="md:border-0 lg:border-0"
                        name="Designation"
                        :rules="{ required: true }"
                      ></base-input>
                    </div>
                    <div class="mob-hidden">
                      <p class="input-title">Company Name</p>
                      <base-input
                        v-model="company"
                        placeholder="Enter your Company Name"
                        class="md:border-0 lg:border-0"
                        name="Company Name"
                        :rules="{ required: true }"
                      ></base-input>
                    </div>
                    <div class="">
                      <p class="input-title">Mobile No.</p>
                      <base-input
                        v-model="mobile"
                        placeholder="Enter your Mobile No."
                        class="md:border-0 lg:border-0"
                        name="Mobile No."
                        :rules="{
                          required: true,
                          numeric: true,
                          min: 10,
                          max: 10,
                        }"
                      ></base-input>
                    </div>
                  </div>
                  <div class="pt-6 md:mb-0 lg:mb-0 mb-14">
                    <p class="input-title">Message</p>
                    <b-form-textarea
                      v-model="message"
                      placeholder="Enter your Message"
                      rows="2"
                      class="md:border-0 lg:border-0"
                    ></b-form-textarea>
                  </div>
                  <!-- <vue-recaptcha
                      sitekey="6LfZLWkeAAAAALwhHWrc9kPpHsS3KOGzMZNXXNW6"
                      :loadRecaptchaScript="true"
                      ref="recaptcha"
                    > -->

                  <div class="mt-8">
                    <b-form-checkbox
                      class="text-white"
                      :disabled="isValidForm"
                      id="checkbox-1"
                      value=" I have read and agreed to these"
                      unchecked-value="I have read and agreed to these"
                      v-model="status"
                    >
                      <p>
                        <strong
                          >{{ status }}
                          <u class="ublue" @click="editModal = true"
                            >terms and conditions</u
                          ></strong
                        >
                      </p></b-form-checkbox
                    >
                  </div>
                  <div class="mt-8">
                    <b-button
                      type="submit"
                      variant="secondary"
                      :disabled="isdisabled"
                      class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 border-2 text-base font-bold"
                      >Submit</b-button
                    >
                  </div>
                  <!-- </vue-recaptcha>  -->
                </b-form>
              </validation-observer>

              <div class="absolute bottom-0 right--6rem mob-hidden">
                <img
                  src="../../../assets/images/caregiver/plant.svg"
                  alt="plant"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script
  src="https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit"
  async
  defer
></script>

<script>
import emailMixin from "@/mixins/email";
import { mapState } from "vuex";
//import { component } from 'vue/types/umd';
// import  VueRecaptcha  from 'vue-recaptcha';
// src = "https://www.google.com/recaptcha/api.js?render=6LfZLWkeAAAAALwhHWrc9kPpHsS3KOGzMZNXXNW6";

export default {
  mixins: [emailMixin],
  data() {
    return {
      name: "",
      email: "",
      designation: "",
      company: "",
      mobile: "",
      message: "",
      status: "I have read and agreed to these",
      editModal: false,
    };
  },

  // components: {VueRecaptcha},
  computed: {
    isValidForm() {
      if (this.otp == "") {
        return true;
      } else if (
        this.name != "" &&
        this.email != "" &&
        this.designation != "" &&
        this.company != "" &&
        this.mobile != "" &&
        this.email != "" &&
        this.message != ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    isdisabled() {
      if (this.status == "I have read and agreed to these") {
        return true;
      } else {
        return false;
      }
    },
    ...mapState("auth", { user: "user" }),
  },
  methods: {
    async reset() {
      (this.name = ""),
        (this.email = ""),
        (this.designation = ""),
        (this.company = ""),
        (this.mobile = ""),
        (this.message = "");
    },
    async handleSend() {
      const to = ["Bhavana.issar@caregiversaathi.co.in"];
      const bcc = [
        "vimala.mv@caregiversaathi.co.in",
        "dona.mohapatra@caregiversaathi.co.in",
      ];
      // const to = [
      //   "Bhavana.issar@caregiversaathi.co.in",
      //   "vimala.mv@caregiversaathi.co.in",
      // ];
      const subject = "Healthcare Professional Group Offers";
      const body = `
      Name: ${this.name}<br />
      Email Address: ${this.email}<br />
      Designation: ${this.designation}<br />
      Company Name: ${this.company}<br />
      Mobile No.: ${this.mobile}<br />
      Message: ${this.message}<br />
      `;
      await this.sendEmail(to, subject, body, [], bcc);
      this.$refs.formValidator.reset();

      this.successAlert();
      this.reset();
    },
    // onEvent() {
    //   this.$refs.recaptcha.execute();
    // },

    //  async handleOnlick(e){
    //    e.preventDefault();
    //    grecaptcha.ready(this.handleOnlick() {
    //      grecaptcha.execute('6LfZLWkeAAAAALwhHWrc9kPpHsS3KOGzMZNXXNW6', {action: 'submit'}).then(this.handleOnlick(token))
    //    });
    //  });
    // //  async onSubmit(token){
    // //  console.getElementById("demo-form").submit();
    // // },
  },
  mounted() {
    if (!!Object.keys(this.user).length) {
      this.email = this.user.email;
      this.name = `${this.user.firstname} ${this.user.lastname}`;
      this.mobile = this.user.mobile;
      this.designation = this.user["designation"]
        ? this.user["designation"]
        : "";
      this.company = this.user["companyName"] ? this.user["companyName"] : "";
    }
  },
};
</script>
<style>
.ublue {
  color: rgb(86, 86, 248);
}
</style>
